"use client";

import { ErrorPage } from "@/ui/error-page";
import type { Dictionary } from "@/utils/dictionaries/get-dictionary";
import {
  ErrorPageTranslationsProvider,
  useErrorPageTranslations,
} from "@/utils/error-page-translations-context";

const fallbackTranslations: Dictionary["errorPage"] = {
  subHeading404: "Page not found",
  subHeading500: "Internal server error",
  button4xx: "Back to homepage",
  button5xx: "Reload page",
  messageLine1: "Oops! This page took a wrong turn.",
  messageLine2: "Let’s guide you back to where you need to go.",
};

function NotFoundContent() {
  const errorTranslations = useErrorPageTranslations();

  const handleButtonClick = () => {};

  const shouldShowButton = false;

  return (
    <ErrorPage
      buttonText={shouldShowButton ? errorTranslations.button4xx : undefined}
      description={[
        errorTranslations.messageLine1,
        errorTranslations.messageLine2,
      ]}
      errorCode="404"
      onButtonClick={shouldShowButton ? handleButtonClick : undefined}
      title={errorTranslations.subHeading404}
    />
  );
}

export default function NotFound() {
  return (
    <ErrorPageTranslationsProvider errorPageTranslations={fallbackTranslations}>
      <NotFoundContent />
    </ErrorPageTranslationsProvider>
  );
}
